/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unauthorized model
 * @export
 * @interface Unauthorized
 */
export interface Unauthorized {
    /**
     * Unauthorized message
     * @type {string}
     * @memberof Unauthorized
     */
    error: string;
}

/**
 * Check if a given object implements the Unauthorized interface.
 */
export function instanceOfUnauthorized(value: object): value is Unauthorized {
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function UnauthorizedFromJSON(json: any): Unauthorized {
    return UnauthorizedFromJSONTyped(json, false);
}

export function UnauthorizedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Unauthorized {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'],
    };
}

export function UnauthorizedToJSON(json: any): Unauthorized {
    return UnauthorizedToJSONTyped(json, false);
}

export function UnauthorizedToJSONTyped(value?: Unauthorized | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

